import { Component } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { DoorComponent } from 'src/app/models/components/objectComponents/DoorComponent';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { ComponentNames } from 'src/app/helper/componentNames';
import { EntranceDoorComponent } from 'src/app/models/components/objectComponents/EntranceDoorComponent';
import { MultiPurposeAreaComponent } from 'src/app/models/components/objectComponents/MultiPurposeAreaComponent';
import { PersonsPerSquareMeterComponent } from 'src/app/models/components/commonComponents/PersonsPerSquareMeterComponent';
import { userHasFeature } from 'src/app/helper/userHasFeature';
import { AuthService } from 'src/app/services/auth.service';
import { FeatureEnum } from 'src/app/models/enums/FeatureEnum';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-entrancedoor',
  templateUrl: './entrancedoor.component.html',
  styleUrls: ['./entrancedoor.component.scss']
})
export class EntrancedoorViewComponent extends BaseAdvancedPropertyViewComponent {
  door: DoorComponent;
  entranceDoor: EntranceDoorComponent;
  multiPurposeAreaComponent: MultiPurposeAreaComponent;
  personsPerSquareMeterComponent: PersonsPerSquareMeterComponent;
  doorWingTypes = [{ ID: 1, Name: "Einflügelig" }, { ID: 2, Name: "Zweiflügelig" }];
  physicalSplitElementSource = [{ ID: 1, Name: "No separating element" }, { ID: 2, Name: "One separating element" }, { ID: 3, Name: "Two separating elements" }];
  // indicator to hide propertys which are currently not available
  show: boolean = false;
  showFeatureBycicleAmountSingle: boolean;
  showFeatureSkiAmountSingle: boolean;
  showFeatureStrollerAmountSingle: boolean;
  stepAmounts = [{ ID: 0, Name: "0" }, { ID: 1, Name: "1" }, { ID: 2, Name: "2" },{ ID: 3, Name: "3" },{ ID: 4, Name: "4" }];

  constructor(private authService: AuthService, public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.door = getComponentFromSource(ComponentNames.doorComponent, this.items);
    this.entranceDoor = getComponentFromSource(ComponentNames.entranceDoorComponent, this.items);
    this.multiPurposeAreaComponent = getComponentFromSource(ComponentNames.multiPurposeAreaComponent, this.items);
    this.personsPerSquareMeterComponent = getComponentFromSource(ComponentNames.personsPerSquareMeterComponent, this.items);
    this.loadFeatures();

  }

  loadFeatures() {
    let tmpShowFeatureBycicleAmountSingle = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideBycicleAmountSingleSashDoor);
    let tmpShowFeatureSkiAmountSingle = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideSkiAmountSingleSashDoor);
    let tmpShowFeatureStrollerAmountSingle = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideStrollerAmountSingleSashDoor);


    let tmpShowFeatureBycicleAmountDouble = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideBycicleAmountDoubleSashDoor);
    let tmpShowFeatureSkiAmountDouble = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideSkiAmountDoubleSashDoor);
    let tmpShowFeatureStrollerAmountDouble = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideStrollerAmountDoubleSashDoor);

    if (this.door.doorWingType == 1) {
      if (tmpShowFeatureBycicleAmountSingle) {
        this.showFeatureBycicleAmountSingle = true;
      }
      else {
        this.showFeatureBycicleAmountSingle = false;
      }

      if (tmpShowFeatureSkiAmountSingle) {
        this.showFeatureSkiAmountSingle = true;
      }
      else {
        this.showFeatureSkiAmountSingle = false;
      }

      if (tmpShowFeatureStrollerAmountSingle) {
        this.showFeatureStrollerAmountSingle = true;
      }
      else {
        this.showFeatureStrollerAmountSingle = false;
      }
    }

    if (this.door.doorWingType == 2) {
      if (tmpShowFeatureBycicleAmountDouble) {
        this.showFeatureBycicleAmountSingle = true;
      }
      else {
        this.showFeatureBycicleAmountSingle = false;
      }

      if (tmpShowFeatureSkiAmountDouble) {
        this.showFeatureSkiAmountSingle = true;
      }
      else {
        this.showFeatureSkiAmountSingle = false;
      }

      if (tmpShowFeatureStrollerAmountDouble) {
        this.showFeatureStrollerAmountSingle = true;
      }
      else {
        this.showFeatureStrollerAmountSingle = false;
      }
    }

  }

  changeSteps(selectedValue: number) {
    this.entranceDoor.stepAmount = selectedValue;
  };

  changeDoorWingType(selectedValue: number) {
    this.door.doorWingType = selectedValue;
  }

  changeSplitElement(value: number) {
    this.entranceDoor.physicalSplitElement = value;
  }

  saveButtonDisabledState(): boolean {
    return false;
  }
}
